import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_azfo7639ir: FaireBrandEntity = {
  token: "b_azfo7639ir",
  type: "brand",
  name: "Winged",
  avatarUrl:
    "https://cdn.faire.com/fastly/6f4f58d0f89c970d29a48657c680bc1c0fabbfe2fbd65f6749f83c51bb6caed3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/741ebe0544f7e4952ab420a1ce1ad5482173745b42ac83bf4b6c04fcd8c2ac81.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6f4f58d0f89c970d29a48657c680bc1c0fabbfe2fbd65f6749f83c51bb6caed3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/741ebe0544f7e4952ab420a1ce1ad5482173745b42ac83bf4b6c04fcd8c2ac81.png",
  location: "Hallandale Beach, FL, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 16,
  isInsider: true,
  description:
    "Winged is a brand that specializes products that are formulated exclusively for women featuring feel-good ingredients like Evening Primrose, Chaste Berry, and more. We pride ourselves in creating products that aim to address the most common issues facing today’s woman such as stress, mood support, and sleep improvement and hormonal balance. We believe that when a woman feels good, and it’s bogged down by stress and anxiety, that she is unstoppable. We want to help her get there. \n\nOur ingestible supplements are filled with mood boosting herbs and botanicals. The packaging is gorgeous is fits beautifully in all lifestyle and beauty boutiques. \n\nWinged has made a consistent effort towards assisting those in need through charitable donations, long term partnerships with organizations such as Girls For a Change for Moste, and empowering over thousands of women across the U.S to be their best selves since launching our brand.\n\nOur beautiful brand is mission driven and we would love to partner with you to help more women feel their best. We are veery supportive when it comes to displays, marketing materials and POP displays. \n\nPlease reach out to learn more and join our Winged Woman family. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:21.390Z",
    importedBy: "entity-db-cli",
  },
};
